import React, { useState, useEffect, useRef } from "react";
import { QRCode } from "react-qrcode-logo";
import { IoClipboard, IoSend } from "react-icons/io5";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { getDatabase, ref, child, set, onValue } from "firebase/database";
import {
  Container,
  Table,
  Form,
  Button,
  Row,
  Col,
  InputGroup,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import logo from "../assets/img/logo.png";
import AppConfig from "../service/firebase";
import { formatDate, isValidHttpUrl, pad } from "../utility/utility";

const db = getDatabase(AppConfig);

const Shorturl = () => {
  const formRef = useRef(null);
  const [data, setData] = useState([]);
  const [Uid, setUid] = useState();
  const [url, setUrl] = useState("");
  const [shortUrl, setShortUrl] = useState("");
  const [qrcode, setQrcode] = useState("");
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const query = ref(db, "shortlink");
    onValue(query, async (snapshot) => {
      if (snapshot.exists()) {
        let dataArr = [];
        snapshot.forEach((childSnapshot) => {
          dataArr.push({
            id: childSnapshot.key,
            email: childSnapshot.val().email,
            url: childSnapshot.val().url,
            timestamp: childSnapshot.val().timestamp,
          });
        });

        setData(dataArr.reverse());

        await setUid(Object.keys(snapshot.val()).length + 1);
      } else {
        await setUid(1);
        console.log("No data available");
      }
    });
  }, []);

  const shortenUrl = (uid) => {
    if (uid) {
      if (isValidHttpUrl(url)) {
        const query = ref(db);
        Swal.fire({
          title: "Please enter your email address",
          input: "email",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "OK",
          confirmButtonColor: "#0d6efd",
          showLoaderOnConfirm: true,
          preConfirm: (val) => {
            set(child(query, `shortlink/` + pad(uid)), {
              email: val,
              url: url,
              timestamp: new Date().getTime(),
            })
              .then(() => {
                setUrl("");
                setQrcode(window.location.href + pad(uid));
                setShortUrl(window.location.href + pad(uid));
                formRef.current.value = "";
              })
              .catch((error) => {
                console.log(error);
              });
          },
          allowOutsideClick: () => !Swal.isLoading(),
        });
      } else {
        Swal.fire({
          title: "URL invalid",
          icon: "warning",
          confirmButtonColor: "#0d6efd",
        });
      }
    }
  };

  const copyToClipboard = (val) => {
    var textField = document.createElement("textarea");
    textField.innerText = val;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    setShowToast(true);
  };

  const downloadCode = () => {
    const canvas = document.getElementById("QR");
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `your_name.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  return (
    <>
      <header className="page-header">
        <Container fluid>
          <Row>
            <Col md="6" sm="12" className="mx-auto">
              <div style={{ marginTop: "1.8rem" }} className="text-center">
                <img src={logo} width="250" alt="logo" />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section>
        <Container>
          <Col md="12" sm="12" className="mx-auto">
            <div className="sec-card text-center">
              <h4 className="mt-3">HST Shortener URL And QrCode Generator</h4>
              <Row>
                <Col md="12" sm="12">
                  <InputGroup className="mt-5 mb-3">
                    <Form.Control
                      ref={formRef}
                      type="text"
                      placeholder="Enter URL"
                      aria-label="url"
                      aria-describedby="url"
                      onChange={(e) => {
                        setUrl(e.target.value);
                      }}
                    />
                    <Button id="url" onClick={() => shortenUrl(Uid)}>
                      Shorten
                    </Button>
                  </InputGroup>
                  {shortUrl ? (
                    <>
                      <p className="shortUrl mt-5">
                        <a href={shortUrl} target="_blank" rel="noreferrer">
                          {shortUrl}
                        </a>{" "}
                        <Button
                          variant="primary"
                          onClick={() => copyToClipboard(shortUrl)}
                        >
                          <IoClipboard className="icon" />
                        </Button>
                      </p>
                    </>
                  ) : (
                    ""
                  )}

                  {qrcode ? (
                    <>
                      <div className="mt-5" style={{ width: "100%" }}>
                        <QRCode
                          size="300"
                          value={qrcode}
                          // logoImage={logo}
                          // logoWidth="100"
                          // logoHeight="100"
                          enableCORS={true}
                          qrStyle="squares"
                          eyeRadius={10}
                          id={"QR"}
                        />
                      </div>
                      <Button className="mt-4" onClick={downloadCode}>
                        Download
                      </Button>
                    </>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Container>
      </section>

      <section>
        <Container>
          <Row>
            <Col md="12" sm="12" className="mx-auto">
              <div className="list-card text-center">
                <h4>รายการล่าสุด</h4>
                {data.length ? (
                  <>
                    <Row className="mx-auto">
                      <Col md="12" sm="12">
                        <Table responsive striped borderless>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>email</th>
                              <th>URL</th>
                              <th>Cerate</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((val, index) => (
                              <tr key={val.id}>
                                <td>{index + 1}</td>
                                <td>{val.email}</td>
                                <td>
                                  <a
                                    id={val.id}
                                    target="_blank"
                                    rel="noreferrer"
                                    href={window.location.href + val.id}
                                  >
                                    {window.location.href + val.id}
                                  </a>
                                </td>
                                <td>{formatDate(val.timestamp)}</td>
                                <td>
                                  <Button
                                    id="click"
                                    href={window.location.href + val.id}
                                    target="_blank"
                                  >
                                    <IoSend className="icon" />
                                  </Button>{" "}
                                  <Button
                                    variant="primary"
                                    onClick={() =>
                                      copyToClipboard(
                                        window.location.href + val.id
                                      )
                                    }
                                  >
                                    <IoClipboard className="icon" />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <ToastContainer containerPosition position="top-center">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
        >
          <Toast.Body>copied</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default Shorturl;
